import axios from 'axios';
import { BehaviorSubject } from 'rxjs';

import { IsLocalHost } from '../utils/enviroment';
import { localStorageKey, viewTypeStorageKey } from '../constants';
import { getApiUrl } from '../helpers/api-url';
import { userService } from './userService.service';

//TODO: what if the token is valid but user data is not?
const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem(localStorageKey)));

export const authenticationService = {
    login,
    logout,
    authenticate,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() {
        return currentUserSubject.value;
    },
};

//TODO: what if the API call fails?
function authenticate() {
    if (IsLocalHost()) {
        userService
            .loadUserData()
            .then((data) => {
                initializeAppData(data);
            })
            .catch((error) => alert('Error logging in. Check your token expiration.'));
    } else {
        window.location.replace(getApiUrl() + '/user/authenticate');
    }
}

async function login(token: string) {
    //use a custom client to isolate the request
    const httpClient = axios.create({ headers: { Authorization: `Bearer ${token}` } });
    const loginRequest = { token };

    const { data, status } = await httpClient.post(getApiUrl() + '/user/login', loginRequest);

    //un-authorized request
    if (status === 401) {
        logout();
        throw new Error('Error logging in user');
    }

    initializeAppData(data);

    return data;
}

function logout() {
    localStorage.removeItem(localStorageKey);
    localStorage.removeItem(viewTypeStorageKey);
    currentUserSubject.next(null);
}

function initializeAppData(data) {
    userService.saveUserView(data);
    userService.saveUserData(data);
    currentUserSubject.next(data);
}
